import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Ask from './pages/Ask';
import Calculators from './pages/Calculators';
import Pricing from './pages/Pricing';
import Courses from './pages/Courses';
import Market from './pages/Market';
import MarketPulse from './pages/MarketPulse';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Account from './pages/Account';
import GamePlan from './pages/GamePlan';
import HowTo from './pages/HowTo';
import Playbooks from './pages/Playbooks';
import HealthScore from './pages/HealthScore';
import Tracker from './pages/Tracker';
import Brief from './pages/Brief';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Glossary from './pages/Glossary';
import GlossaryTerm from './pages/GlossaryTerm';
import SavingsByAge from './pages/SavingsByAge';
import SavingsByAgeHub from './pages/SavingsByAgeHub';
import SavingsByStateHub from './pages/SavingsByStateHub';
import MarketReturnsHub from './pages/MarketReturnsHub';
import CryptoCorner from './pages/CryptoCorner';
import ContributionLimits from './pages/ContributionLimits';
import MarketReturns from './pages/MarketReturns';
import SavingsByState from './pages/SavingsByState';
import CreditScoreGuide from './pages/CreditScoreGuide';
import MoneyTypeQuiz from './pages/MoneyTypeQuiz';
import Community from './pages/Community';
import About from './pages/About';
import SmartMoney from './pages/SmartMoney';
import PlaybookDetail from './pages/PlaybookDetail';
import CalculatorDetail from './pages/CalculatorDetail';
import CourseDetailPage from './pages/CourseDetailPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ask" element={<Ask />} />
        <Route path="/calculators" element={<Calculators />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/courses" element={<Courses />} />

        <Route path="/market" element={<Market />} />
        <Route path="/market-pulse" element={<MarketPulse />} />
        <Route path="/crypto-corner" element={<CryptoCorner />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/account" element={<Account />} />
        <Route path="/gameplan" element={<GamePlan />} />
        <Route path="/howto" element={<HowTo />} />
        <Route path="/playbooks" element={<Playbooks />} />
        <Route path="/playbooks/:id" element={<PlaybookDetail />} />
        <Route path="/calculators/:id" element={<CalculatorDetail />} />
        <Route path="/courses/:id" element={<CourseDetailPage />} />
        <Route path="/healthscore" element={<HealthScore />} />
        <Route path="/tracker" element={<Tracker />} />
        <Route path="/brief" element={<Brief />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/glossary/:slug" element={<GlossaryTerm />} />
        <Route path="/credit-score-guide" element={<CreditScoreGuide />} />
              <Route path="/savings-by-age" element={<SavingsByAgeHub />} />
              <Route path="/savings-by-age/:age" element={<SavingsByAge />} />
        <Route path="/contribution-limits/:account/:year" element={<ContributionLimits />} />
        <Route path="/market-returns" element={<MarketReturnsHub />} />
        <Route path="/market-returns/:index/:year" element={<MarketReturns />} />
        <Route path="/savings-by-state" element={<SavingsByStateHub />} />
        <Route path="/savings-by-state/:state" element={<SavingsByState />} />
        <Route path="/quiz" element={<MoneyTypeQuiz />} />
        <Route path="/community" element={<Community />} />
        <Route path="/about" element={<About />} />
        <Route path="/smart-money" element={<SmartMoney />} />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;
